import { render } from "./LocationIndex.vue?vue&type=template&id=418be8b8"
import script from "./LocationIndex.vue?vue&type=script&lang=ts"
export * from "./LocationIndex.vue?vue&type=script&lang=ts"
script.render = render

export default script